{
  "labels": {
    "paste": "Senṭeḍ",
    "pasteAsPlaintext": "",
    "pasteCharts": "Senṭeḍ udlifen",
    "selectAll": "Fren akk",
    "multiSelect": "Rnu aferdis ɣer tefrayt",
    "moveCanvas": "Smutti taɣzut n usuneɣ",
    "cut": "Gzem",
    "copy": "Nɣel",
    "copyAsPng": "Nɣel ɣer tecfawit am PNG",
    "copyAsSvg": "Nɣel ɣer tecfawit am SVG",
    "copyText": "Nɣel ɣer tecfawit am uḍris",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "Awi ɣer sdat",
    "sendToBack": "Awi s agilal",
    "bringToFront": "Err ɣer deffir",
    "sendBackward": "Awi ɣer deffir",
    "delete": "Kkes",
    "copyStyles": "Nɣel iɣunab",
    "pasteStyles": "Senṭeḍ iɣunab",
    "stroke": "Azizdew",
    "background": "Agilal",
    "fill": "Taččart",
    "strokeWidth": "Tehri n yizirig",
    "strokeStyle": "Aɣanib n tizirig",
    "strokeStyle_solid": "Aččuran",
    "strokeStyle_dashed": "S tjerriḍin",
    "strokeStyle_dotted": "S tenqiḍin",
    "sloppiness": "Astehzi",
    "opacity": "Tiḍullest",
    "textAlign": "Areyyec n uḍris",
    "edges": "Leryuf",
    "sharp": "Yemsed",
    "round": "Imdewer",
    "arrowheads": "Ixfawen n tenccabt",
    "arrowhead_none": "Ulac",
    "arrowhead_arrow": "Taneccabt",
    "arrowhead_bar": "Afeggag",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "Akerdis",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "Tiddi n tsefsit",
    "fontFamily": "Tawacult n tsefsiyin",
    "addWatermark": "Seddu \"Yettwaxdem s Excalidraw\"",
    "handDrawn": "Asuneɣ s ufus",
    "normal": "Amagnu",
    "code": "Tangalt",
    "small": "Meẓẓi",
    "medium": "Alemmas",
    "large": "Ameqran",
    "veryLarge": "Meqqer aṭas",
    "solid": "Aččuran",
    "hachure": "Azerreg",
    "zigzag": "",
    "crossHatch": "Azerreg anmidag",
    "thin": "Arqaq",
    "bold": "Azuran",
    "left": "Azelmaḍ",
    "center": "Talemmast",
    "right": "Ayfus",
    "extraBold": "Azuran aṭas",
    "architect": "Amasdag",
    "artist": "Anaẓur",
    "cartoonist": "Amefɣul",
    "fileTitle": "Isem n ufaylu",
    "colorPicker": "Amafran n yini",
    "canvasColors": "Yettwaseqdec di teɣzut n usuneɣ",
    "canvasBackground": "Agilal n teɣzut n usuneɣ",
    "drawingCanvas": "Taɣzut n usuneɣ",
    "layers": "Tissiyin",
    "actions": "Tigawin",
    "language": "Tutlayt",
    "liveCollaboration": "Amɛiwen s srid...",
    "duplicateSelection": "Sisleg",
    "untitled": "War azwel",
    "name": "Isem",
    "yourName": "Isem-ik (im)",
    "madeWithExcalidraw": "Yettwaxdem s Excalidraw",
    "group": "Segrew tafrayt",
    "ungroup": "Kkess asegrew i tefrayt",
    "collaborators": "Imɛiwnen",
    "showGrid": "Beqqeḍ aferrug",
    "addToLibrary": "Rnu ɣer temkarḍit",
    "removeFromLibrary": "Kkes si temkarḍit",
    "libraryLoadingMessage": "Asali n temkarḍit…",
    "libraries": "Snirem timkarḍiyin",
    "loadingScene": "Asali n usayes…",
    "align": "Reyyec",
    "alignTop": "Areyyec uksawen",
    "alignBottom": "Areyyec ukessar",
    "alignLeft": "Reyyec s azelmaḍ",
    "alignRight": "Areyyec s ayfus",
    "centerVertically": "Di tlemmast s ibeddi",
    "centerHorizontally": "Di tlemmast s uglawi",
    "distributeHorizontally": "Freq s uglawi",
    "distributeVertically": "Freq s yibeddi",
    "flipHorizontal": "Tuttya taglawant",
    "flipVertical": "Tuttya tubdidt",
    "viewMode": "Askar n tmuɣli",
    "share": "Bḍu",
    "showStroke": "Beqqeḍ amelqaḍ n yini n yizirig",
    "showBackground": "Beqqeḍ amelqaḍ n yini n ugilal",
    "toggleTheme": "Snifel asentel",
    "personalLib": "Tamkarḍit tudmawant",
    "excalidrawLib": "Tamkarḍit n Excalidraw",
    "decreaseFontSize": "Senqes tiddi n tsefsit",
    "increaseFontSize": "Sali tiddi n tsefsit",
    "unbindText": "Serreḥ iweḍris",
    "bindText": "Arez aḍris s anagbar",
    "createContainerFromText": "",
    "link": {
      "edit": "Ẓreg aseɣwen",
      "editEmbed": "",
      "create": "Snulfu-d aseɣwen",
      "createEmbed": "",
      "label": "Aseɣwen",
      "labelEmbed": "",
      "empty": ""
    },
    "lineEditor": {
      "edit": "Ẓreg izirig",
      "exit": "Ffeɣ seg umaẓrag n yizirig"
    },
    "elementLock": {
      "lock": "Sekkeṛ",
      "unlock": "Serreḥ",
      "lockAll": "Sekkeṛ akk",
      "unlockAll": "Serreḥ akk"
    },
    "statusPublished": "Yeffeɣ-d",
    "sidebarLock": "Eǧǧ afeggag n yidis yeldi",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "Ulac iferdisen yettwarnan yakan...",
    "hint_emptyLibrary": "Fren aferdis di teɣzut nusuneɣ akken at-ternuḍ dagi, neɣ sbedd tamkarḍit seg usarsay azayez, ukessar-agi.",
    "hint_emptyPrivateLibrary": "Fren aferdis di teɣzut nusuneɣ akken at-ternuḍ dagi."
  },
  "buttons": {
    "clearReset": "Ales awennez n teɣzut n usuneɣ",
    "exportJSON": "Sifeḍ afaylu",
    "exportImage": "Sifeḍ tugna...",
    "export": "Sekles di...",
    "copyToClipboard": "Nɣel ɣer tecfawit",
    "save": "Sekles deg ufaylu amiran",
    "saveAs": "Sekles am",
    "load": "Ldi",
    "getShareableLink": "Awi-d aseɣwen n beṭṭu",
    "close": "Mdel",
    "selectLanguage": "Fren tutlayt",
    "scrollBackToContent": "Uɣal s agbur",
    "zoomIn": "Simɣur",
    "zoomOut": "Simẓi",
    "resetZoom": "Ales awennez n usemɣer",
    "menu": "Umuɣ",
    "done": "Ifukk",
    "edit": "Ẓreg",
    "undo": "Sefsex",
    "redo": "Err-d",
    "resetLibrary": "Ales awennez n temkarḍit",
    "createNewRoom": "Snulfu-d taxxamt tamaynutt",
    "fullScreen": "Agdil aččuran",
    "darkMode": "Askar imsulles",
    "lightMode": "Askar afaw",
    "zenMode": "Askar Zen",
    "objectsSnapMode": "",
    "exitZenMode": "Ffeɣ seg uskar Zen",
    "cancel": "Sefsex",
    "clear": "Sfeḍ",
    "remove": "Kkes",
    "embed": "",
    "publishLibrary": "Ẓreg",
    "submit": "Azen",
    "confirm": "Sentem",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Ayagi ad isfeḍ akk taɣzut n usuneɣ. Tetḥeqqeḍ?",
    "couldNotCreateShareableLink": "D awezɣi asnulfu n useɣwen n beṭṭu.",
    "couldNotCreateShareableLinkTooBig": "D awezɣi asnulfu n useɣwen n beṭṭu. Asayes ɣezzif aṭas",
    "couldNotLoadInvalidFile": "D awezɣi asali n ufaylu armeɣtu",
    "importBackendFailed": "Takterḍ seg uɣawas n deffir ur teddi ara.",
    "cannotExportEmptyCanvas": "D awezɣi asifeḍ n teɣzut n usuneɣ tilemt.",
    "couldNotCopyToClipboard": "Ulamek anɣal ɣer tecfawit.",
    "decryptFailed": "D awezɣi tukksa n uwgelhen i yisefka.",
    "uploadedSecurly": "Asili yettwasɣelles s uwgelhen ixef s ixef, ayagi yebɣa ad d-yini belli aqeddac n Excalidraw akked medden ur zmiren ara ad ɣren agbur.",
    "loadSceneOverridePrompt": "Asali n wunuɣ uffiɣ ad isemselsi agbur-inek (m) yellan. Tebɣiḍ ad tkemmeleḍ?",
    "collabStopOverridePrompt": "Aḥbas n tɣimit ad yesefsex unuɣ-inek (m) yettwaḥerzen yakan s wudem adigan. Tetḥeqqeḍ?\n(Ma tebɣiḍ ad teǧǧeḍ unuɣ-inek (m) adigan, mdel iccer n yiminig, deg umḍiq.)",
    "errorAddingToLibrary": "Ulamek ara yettwarnu uferdis ɣer temkarḍit",
    "errorRemovingFromLibrary": "Ulamek ara yettwakkes uferdis si temkarḍit",
    "confirmAddLibrary": "Ayagi adirnu talɣa (win) {{numShapes}} ɣer temkarḍit-inek (m). Tetḥeqqeḍ?",
    "imageDoesNotContainScene": "Tugna-agi tettban-d ur tesɛi ara isefka n usayes. Tesremdeḍ aseddu n usayes deg usifeḍ?",
    "cannotRestoreFromImage": "Asayes ulamek ara d-yettwarr seg ufaylu-agi n tugna",
    "invalidSceneUrl": "Ulamek taktert n usayes seg URL i d-ittunefken. Ahat mačči d tameɣtut neɣ ur tegbir ara isefka JSON n Excalidraw.",
    "resetLibrary": "Ayagi ad isfeḍ tamkarḍit-inek•m. Tetḥeqqeḍ?",
    "removeItemsFromsLibrary": "Ad tekkseḍ {{count}} n uferdis (en) si temkarḍit?",
    "invalidEncryptionKey": "Tasarut n uwgelhen isefk ad tesɛu 22 n yiekkilen. Amɛiwen srid yensa.",
    "collabOfflineWarning": "Ulac tuqqna n internet.\nIbedilen-ik ur ttwaklasen ara!"
  },
  "errors": {
    "unsupportedFileType": "Anaw n ufaylu ur yettwasefrak ara.",
    "imageInsertError": "D awezɣi tugra n tugna. Eɛreḍ tikkelt-nniḍen ardeqqal...",
    "fileTooBig": "Afaylu meqqer aṭas. Tiddi tafellayt yurgen d {{maxSize}}.",
    "svgImageInsertError": "D awezɣi tugra n tugna SVG. Acraḍ SVG yettban-d d armeɣtu.",
    "failedToFetchImage": "",
    "invalidSVGString": "SVG armeɣtu.",
    "cannotResolveCollabServer": "Ulamek tuqqna s aqeddac n umyalel. Ma ulac uɣilif ales asali n usebter sakin eɛreḍ tikkelt-nniḍen.",
    "importLibraryError": "Ur d-ssalay ara tamkarḍit",
    "collabSaveFailed": "Ulamek asekles deg uzadur n yisefka deg ugilal. Ma ikemmel wugur, isefk ad teskelseḍ afaylu s wudem adigan akken ad tetḥeqqeḍ ur tesruḥuyeḍ ara amahil-inek•inem.",
    "collabSaveFailed_sizeExceeded": "Ulamek asekles deg uzadur n yisefka deg ugilal, taɣzut n usuneɣ tettban-d temqer aṭas. Isefk ad teskelseḍ afaylu s wudem adigan akken ad tetḥeqqeḍ ur tesruḥuyeḍ ara amahil-inek•inem.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "Ayagi yezmer ad d-iglu s truẓi n<bold>Iferdisen n uḍris</bold>deg wunuɣen-inek.",
      "line3": "Ad k-nsemter ad tsexsiḍ aɣewwar-agi. Tzemreḍ ad tḍefreḍ<link>isurifen-agi</link> ɣef wamek ara txedmeḍ.",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Tafrayt",
    "image": "Ger tugna",
    "rectangle": "Asrem",
    "diamond": "Ameɣṛun",
    "ellipse": "Taglayt",
    "arrow": "Taneccabt",
    "line": "Izirig",
    "freedraw": "Suneɣ",
    "text": "Aḍris",
    "library": "Tamkarḍit",
    "lock": "Eǧǧ afecku n tefrayt yermed mbaɛd asuneɣ",
    "penMode": "Askar n yimru - gdel tanalit",
    "link": "Rnu/leqqem aseɣwen i talɣa yettwafernen",
    "eraser": "Sfeḍ",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "Afus (afecku n usmutti n tmuɣli)",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "Tigawin n teɣzut n usuneɣ",
    "selectedShapeActions": "Tigawin n talɣa yettwafernen",
    "shapes": "Talɣiwin"
  },
  "hints": {
    "canvasPanning": "Akken ad tesmuttiḍ taɣzut n usuneɣ, ṭṭef ṛṛuda n umumed, neɣ seqdec afecku Afus",
    "linearElement": "Ssit akken ad tebduḍ aṭas n tenqiḍin, zuɣer i yiwen n yizirig",
    "freeDraw": "Ssit yerna zuɣer, serreḥ ticki tfukeḍ",
    "text": "Tixidest: tzemreḍ daɣen ad ternuḍ aḍris s usiti snat n tikkal anida tebɣiḍ s ufecku n tefrayt",
    "embeddable": "",
    "text_selected": "Ssit snat n tikkal neɣ ssed taqeffalt Kcem akken ad tẓergeḍ aḍris",
    "text_editing": "Ssit Escape neɣ CtrlOrCmd+ENTER akken ad tfakkeḍ asiẓreg",
    "linearElementMulti": "Ssit ɣef tenqiḍt taneggarut neɣ ssed taqeffalt Escape neɣ taqeffalt Kcem akken ad tfakkeḍ",
    "lockAngle": "Tzemreḍ ad tḥettmeḍ tiɣmert s tuṭṭfa n tqeffalt SHIFT",
    "resize": "Tzemreḍ ad tḥettemeḍ assaɣ s tuṭṭfa n tqeffalt SHIFT mi ara tettbeddileḍ tiddi,\nma teṭṭfeḍ ALT abeddel n tiddi ad yili si tlemmast",
    "resizeImage": "Tzemreḍ ad talseḍ tiddi s tilelli s tuṭṭfa n SHIFT,\nṭṭef ALT akken ad talseḍ tiddi si tlemmast",
    "rotate": "Tzemreḍ ad tḥettemeḍ tiɣemmar s tuṭṭfa n SHIFT di tuzzya",
    "lineEditor_info": "Ssed ɣef CtrlOrCmd yerna ssit snat n tikkal neɣ ssed ɣef CtrlOrCmd + Kcem akken ad tẓergeḍ tineqqiḍin",
    "lineEditor_pointSelected": "Ssed taqeffalt kkes akken ad tekkseḍ tanqiḍ (tinqiḍin),\nCtrlOrCmd+D akken ad tsiselgeḍ, neɣ zuɣer akken ad tesmuttiḍ",
    "lineEditor_nothingSelected": "Fren tanqiḍt akken ad tẓergeḍ (ṭṭef SHIFT akken ad tferneḍ aṭas),\nneɣ ṭṭef Alt akken ad ternuḍ tinqiḍin timaynutin",
    "placeImage": "Ssit akken ad tserseḍ tugna, neɣ ssit u zuɣer akken ad tesbaduḍ tiddi-ines s ufus",
    "publishLibrary": "Siẓreg tamkarḍit-inek•inem",
    "bindTextToElement": "Ssed ɣef kcem akken ad ternuḍ aḍris",
    "deepBoxSelect": "Ṭṭef CtrlOrCmd akken ad tferneḍ s telqey, yerna ad trewleḍ i uzuɣer",
    "eraserRevert": "Ssed Alt akken ad tsefsxeḍ iferdisen yettwacerḍen i tukksa",
    "firefox_clipboard_write": "",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "Ulamek abeqqeḍ n teskant",
    "canvasTooBig": "Taɣzut n usuneɣ tezmer ad tili temeqqer aṭas.",
    "canvasTooBigTip": "Tixidest: eɛreḍ ad tesqerbeḍ ciṭ iferdisen yembaɛaden."
  },
  "errorSplash": {
    "headingMain": "Teḍra-d tuccḍa. Eɛreḍ <button>asali n usebter tikkelt-nniḍen.</button>",
    "clearCanvasMessage": "Ma yella tulsa n usali ur tefri ara ugur, eɛreḍ <button>asfaḍ n teɣzut n usuneɣ.</button>",
    "clearCanvasCaveat": " Ayagi ad d-iglu s usṛuḥu n umahil ",
    "trackedToSentry": "Tuccḍa akked umesmagi {{eventId}} tettwasekles deg unagraw-nneɣ.",
    "openIssueMessage": "Nḥuder aṭas akken ur nseddu ara talɣut n usayes-inek (m) di tuccḍa. Ma yella asayes-inek (m) mačči d amaẓlay, ttxil-k (m) xemmem ad ḍefreḍ <button>afecku n weḍfar n yibugen.</button> Ma ulac uɣilif seddu talɣut ukessar-agi s wenɣal akked usenṭeḍ di GitHub issue.",
    "sceneContent": "Agbur n usayes:"
  },
  "roomDialog": {
    "desc_intro": "Tzemreḍ ad d-teɛerḍeḍ medden ɣer usayes-inek (m) amiran akken ad ttekkin yid-k.",
    "desc_privacy": "Ur tqelliq ara, tiɣimit tsseqdac awgelhen ixef s ixef, dɣa ayen ara tsunɣeḍ ad iqqim d amaẓlay. Ula d aqeddac-nneɣ ur yezmir ara ad iwali acu txeddemeḍ.",
    "button_startSession": "Bdu tiɣimit",
    "button_stopSession": "Ḥbes tiɣimit",
    "desc_inProgressIntro": "Tiɣimit n umɛawen s srid tetteddu akka tura.",
    "desc_shareLink": "Bḍu aseɣwen-agi akked medden ukud tebɣiḍ ad temɛawaneḍ:",
    "desc_exitSession": "Aḥbas n tɣimit ad k (m) yesenser si texxamt, maca ad tizmireḍ ad tkemmeleḍ amahil s usayes, s wudem adigan. Ẓer belli ayagi ur yettḥaz ara imdanen-nniḍen, yerna ad izmiren ad kemmelen ad mɛawanen di tsuffeɣt-nnsen.",
    "shareTitle": "Rnu ɣer tɣimit n umɛiwen s srid n Excalidraw"
  },
  "errorDialog": {
    "title": "Tuccḍa"
  },
  "exportDialog": {
    "disk_title": "Sekles deg uḍebsi",
    "disk_details": "Sekles isefka n usayes deg ufaylu ansi ara tizmireḍ ad d-tketreḍ areḍqal.",
    "disk_button": "Sekles deg ufaylu",
    "link_title": "Aseɣwen n beṭṭu",
    "link_details": "Sifeḍ am useɣwen n tɣuri kan.",
    "link_button": "Sifeḍ deg useɣwen",
    "excalidrawplus_description": "Sekles asayes-inek•inem di tallunt n umahil Excalidraw+.",
    "excalidrawplus_button": "Sifeḍ",
    "excalidrawplus_exportError": "Ulamek asifeḍ ɣer Excalidraw+ akka tura..."
  },
  "helpDialog": {
    "blog": "Ɣeṛ ablug-nneɣ",
    "click": "ssit",
    "deepSelect": "Afran s telqey",
    "deepBoxSelect": "Afran s telqey s tnaka, yerna ad tyrewleḍ i uzuɣer",
    "curvedArrow": "Taneccabt izelgen",
    "curvedLine": "Izirig izelgen",
    "documentation": "Tasemlit",
    "doubleClick": "ssit snat n tikkal",
    "drag": "zuɣer",
    "editor": "Amaẓrag",
    "editLineArrowPoints": "Ẓreg tinqiḍin n yizirig/taneccabt",
    "editText": "Ẓreg aḍris/rnu tabzimt",
    "github": "Tufiḍ-d ugur? Azen-aɣ-d",
    "howto": "Ḍfer imniren-nneɣ",
    "or": "neɣ",
    "preventBinding": "Seḥbes tuqqna n tneccabin",
    "tools": "Ifecka",
    "shortcuts": "Inegzumen n unasiw",
    "textFinish": "Fak asiẓreg (amaẓrag n uḍris)",
    "textNewLine": "Rnu ajerriḍ amaynut (amaẓrag n uḍris)",
    "title": "Tallelt",
    "view": "Tamuɣli",
    "zoomToFit": "Simɣur akken ad twliḍ akk iferdisen",
    "zoomToSelection": "Simɣur ɣer tefrayt",
    "toggleElementLock": "Sekkeṛ/kkes asekker i tefrayt",
    "movePageUpDown": "Smutti asebter d asawen/akessar",
    "movePageLeftRight": "Smutti asebter s azelmaḍ/ayfus"
  },
  "clearCanvasDialog": {
    "title": "Sfeḍ taɣzut n usuneɣ"
  },
  "publishDialog": {
    "title": "Suffeɣ-d tamkarḍit",
    "itemName": "Isem n uferdis",
    "authorName": "Isem n umeskar",
    "githubUsername": "Isem n useqdac n GitHub",
    "twitterUsername": "Isem n useqdac n Twitter",
    "libraryName": "Isem n temkarḍit",
    "libraryDesc": "Aglam n temkarḍit",
    "website": "Asmel n web",
    "placeholder": {
      "authorName": "Isem neɣ isem n useqdac inek•inem",
      "libraryName": "Isem n temkarḍit-inek•inem",
      "libraryDesc": "Aglam n temkarḍit-inek•inem akken ad tɛiwneḍ medden ad fehmen aseqdec-inec",
      "githubHandle": "Isem n useqdac n GitHub ( d anefrunan) akken ad tizmireḍ ad tisẓrigeḍ tamkarḍit ticki tuzneḍ-tt i uselken",
      "twitterHandle": "Isem n useqdac n Twitter (d anefrunan) akken ad nẓer anwa ara nsenmer deg udellel di Twitter",
      "website": "Aseɣwen ɣer usmel-inek•inem neɣ wayeḍ (d anefrunan)"
    },
    "errors": {
      "required": "Yettwasra",
      "website": "Sekcem URL ameɣtu"
    },
    "noteDescription": "Azen tamkarḍit-inek•inem akken ad teddu di <link>akaram azayez n temkarḍit</link>i yimdanen-nniḍen ara isqedcen deg wunuɣen-nnsen.",
    "noteGuidelines": "Tamkarḍit teḥwaǧ ad tettwaqbel s ufus qbel. Ma ulac uɣilif ɣer <link>iwellihen</link> send ad tazneḍ. Tesriḍ amiḍan n GitHub akken ad tmmeslayeḍ yerna ad tgeḍ ibeddilen ma yelaq, maca mačči d ayen yettwaḥetmen.",
    "noteLicense": "Mi tuzneḍ ad tqebleḍ akken tamkarḍit ad d-teffeɣ s <link>Turagt MIT, </link>ayen yebɣan ad d-yini belli yal yiwen izmer ad ten-iseqdec war tilist.",
    "noteItems": "Yal aferdis n temkarḍit isefk ad isɛu isem-is i yiman-is akken ad yili wamek ara yettusizdeg. Iferdisen-agi n temkarḍit ad ddun:",
    "atleastOneLibItem": "Ma ulac uɣilif fern ma drus yiwen n uferdis n temkarḍit akken ad tebduḍ",
    "republishWarning": "Tamawt: kra n yiferdisen yettwafernen ttwacerḍen ffeɣen-d/ttwaznen. Isefk ad talseḍ tuzzna n yiferdisen anagar mi ara tleqqemeḍ tamkarḍit neɣ tuzzna yellan."
  },
  "publishSuccessDialog": {
    "title": "Tamkarḍit tettwazen",
    "content": "Tanemmirt-ik•im {{authorName}}. Tamkarḍit-inek•inem tettwazen i weselken. Tzemreḍ ad tḍefreḍ aẓayer<link>dagi</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Ales awennez n temkarḍit",
    "removeItemsFromLib": "Kkes iferdisen yettafernen si temkarḍit"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "Unuɣen-inek (m) ttuwgelhnen seg yixef s ixef dɣa iqeddacen n Excalidraw werǧin ad ten-walin. ",
    "link": "Amagrad ɣef uwgelhen ixef s ixef di Excalidraw"
  },
  "stats": {
    "angle": "Tiɣmeṛt",
    "element": "Aferdis",
    "elements": "Iferdisen",
    "height": "Tattayt",
    "scene": "Asayes",
    "selected": "Yettwafren",
    "storage": "Aḥraz",
    "title": "",
    "total": "Aɣrud",
    "version": "Alqem",
    "versionCopy": "Sit ad tneɣleḍ",
    "versionNotAvailable": "Ur inuḥ ulqem",
    "width": "Tehri"
  },
  "toast": {
    "addedToLibrary": "Yettwarna ɣer temkarḍit",
    "copyStyles": "Iɣunab yettwaneɣlen.",
    "copyToClipboard": "Yettwaɣel ɣer tecfawit.",
    "copyToClipboardAsPng": "{{exportSelection}} yettwanɣel ɣer tecfawit am PNG\n({{exportColorScheme}})",
    "fileSaved": "Afaylu yettwasekles.",
    "fileSavedToFilename": "Yettwasekles di {filename}",
    "canvas": "taɣzut n usuneɣ",
    "selection": "tafrayt",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "Afrawan",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Akk isefka-inek•inem ttwakelsen s wudem adigan deg yiminig-inek•inem.",
      "center_heading_plus": "Tebɣiḍ ad tedduḍ ɣer Excalidraw+ deg umḍiq?",
      "menuHint": "Asifeḍ, ismenyifen, tutlayin, ..."
    },
    "defaults": {
      "menuHint": "Asifeḍ, ismenyifen, d wayen-nniḍen...",
      "center_heading": "",
      "toolbarHint": "Fren afecku tebduḍ asuneɣ!",
      "helpHint": "Inegzumen akked tallelt"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
